export const ID = 'cc69739a-6d79-4684-9b5a-dc7413b1e266';

export const NAME = 'StorageMart Search Results';
